<template>
  <v-card elevation="5">
    <v-card-title>Keyword search</v-card-title>
    <v-card-text>
      <locus-selection-filter-panel @searchAnnot="filterAnnot" @clear="clearLociSelection">
      </locus-selection-filter-panel>
      <v-skeleton-loader :loading="loading" height="100" type="image" class="ma-4" elevation="4">
        <locus-selection-data-table
          v-show="isLoaded"
          class="mx-1"
          :loci="activeLoci"
          @selectLocusId="searchLocus"
        ></locus-selection-data-table>
      </v-skeleton-loader>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import LocusSelectionFilterPanel from '@/components/locus/LocusSelectionFilterPanel.vue';
import LocusSelectionDataTable from '@/components/locus/LocusSelectionDataTable.vue';
export default {
  components: {
    LocusSelectionFilterPanel,
    LocusSelectionDataTable,
  },
  data() {
    return { activeLoci: [], loading: false, isLoaded: false };
  },
  computed: {
    ...mapGetters(['getListOfGeneByAnnot']),
  },
  methods: {
    ...mapActions(['fetchListOfGeneByAnnot']),
    filterAnnot(o) {
      this.$emit('startSearch');
      this.loading = true;
      this.fetchListOfGeneByAnnot(o)
        .then(() => {
          this.activeLoci = this.getListOfGeneByAnnot;
          this.isLoaded = true;
          this.$emit('stopSearch');
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
          this.$emit('stopSearch');
        });
    },
    clearLociSelection() {
      this.loading = false;
      this.isLoaded = false;
      this.activeLoci = [];
    },
    searchLocus(locusid) {
      this.$emit('selectLocusId', locusid);
    },
  },
};
</script>

<style></style>
